import { Component, Input} from '@angular/core';
import { LessonObservationStatus } from '../../models/LessonObservation';

@Component({
    selector: 'app-lesson-observation-status',
    template: `
<span class="badge"
        [class.text-bg-light]="value == 'Draft'"
        [class.text-bg-dark]="value == 'Submitted'"
        [class.text-bg-info]="value == 'Promoted'"
        [class.text-bg-success]="value == 'Approved'"
        [class.text-bg-danger]="value == 'Rejected'">
    {{'lessonObservation_status' + value | translate}}
</span>
`
})
export class LessonObservationStatusComponent {
    @Input() value: LessonObservationStatus;
}
